/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     Name: page.tsx
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import { type FunctionComponent, type ReactNode } from 'react';
import { motion, type MotionProps } from 'framer-motion';

import SEOHead, { type SEOHeadProps } from './seo-head';
/**************************************************************************************************************************
 TYPES / GLOBAL DEFINITIONS
***************************************************************************************************************************/
interface PageProps extends MotionProps {
  headParams: SEOHeadProps;
  children: ReactNode | ReactNode[];
}
/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const Fade: FunctionComponent<PageProps> = ({ headParams, children, ...rest }: PageProps) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        ease: 'easeInOut',
        duration: 0.5
      }}
      {...rest}
    >
      <SEOHead
        title={headParams.title}
        description={headParams.description}
        ogType={headParams.ogType}
        structuredData={headParams.structuredData}
      />
      <main className="w-full h-full">{children}</main>
    </motion.div>
  );
};

const Pages = {
  Fade
};

export default Pages;
